export const SET_PROFILE_USER = "SET_PROFILE_USER";
